(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/sportsbook/components/sbtech-api-impl/assets/javascripts/requests/sbtech-stats-icon.js') >= 0) return;  svs.modules.push('/modules/sportsbook/components/sbtech-api-impl/assets/javascripts/requests/sbtech-stats-icon.js');
"use strict";


const {
  logger
} = svs.sportsbook.sbtech_api_impl;
svs.sportsbook.sbtech_api_impl.fns.requests.sbtech_statsIcon = (_, internals) => _ref => {
  let {
    url
  } = _ref;
  logger.debug("Showing stats: ".concat(url));
  internals.stats.show(url);
};

 })(window);